import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M11.28,6.13a.24.24,0,0,0-.12-.24C9.9,5.1,7,3.86,1.51,3.79a.47.47,0,0,0-.36.14A.48.48,0,0,0,1,4.29V20.05a.49.49,0,0,0,.49.5c5.15.07,8,1.15,9.39,1.93a.23.23,0,0,0,.25,0,.26.26,0,0,0,.12-.21S11.24,6.43,11.28,6.13Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M19.25,17.45a.76.76,0,0,1-.62.74,8.34,8.34,0,0,0-4.3,2.25,8.28,8.28,0,0,0-1,1.43.26.26,0,0,0,0,.3.26.26,0,0,0,.29,0,21.05,21.05,0,0,1,8.88-1.67.49.49,0,0,0,.49-.5V4.29a.48.48,0,0,0-.15-.36.47.47,0,0,0-.36-.14c-1.11,0-2.11.08-3,.17a.26.26,0,0,0-.22.25Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M17.57,16.9a.25.25,0,0,0,.18-.24V1.73a.24.24,0,0,0-.11-.2.23.23,0,0,0-.23,0,7.74,7.74,0,0,0-3.08,1.94,5.49,5.49,0,0,0-1.58,3V19.31a.24.24,0,0,0,.16.23.26.26,0,0,0,.28-.06l0,0A9.31,9.31,0,0,1,17.57,16.9Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }